import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Breakpoint } from '@travel-frontend/core';
import { IconSsl } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { SslContainer } from '../../components/SslWidget/components/SslContainer.js';
import { SslWrapper } from '../../components/SslWidget/components/SslWrapper.js';
export const SslWidget = () => {
  const {
    t
  } = useTranslation('headerNew');
  return _jsx(SslWrapper, {
    children: _jsxs(SslContainer, {
      children: [_jsx(IconSsl, {
        fontScale: "small"
      }), _jsx(Breakpoint, {
        matches: ['lg', 'xl'],
        children: t('sslText')
      })]
    })
  });
};